export default __webpack_public_path__ + "static/media/nine_.dcccac97.jpeg";